import { gql } from '@apollo/client';

export const mutationCreateServiceRequestV3 = gql`
    mutation createServiceRequestV3($serviceData: CreateServiceRequestInputV3!) {
        createServiceRequestV3(serviceData: $serviceData) {
            id
        }
    }
`;
